import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { ProductMappingTab } from '@/components/inventory/storage/temperatures/ProductMappingTab'

/**
 * Storage Temp Mapping as a dialog, for Configure → Products when the user
 * cannot open the Temperatures screen (no Inventory access). Everyone else is
 * sent to that screen's Product mapping tab instead; the content is the same.
 */
export function StorageTempMappingDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Dialog open={open} onOpenChange={next => !next && onClose()}>
      <DialogContent className='flex max-h-[90vh] flex-col sm:max-w-3xl'>
        <DialogHeader>
          <DialogTitle>Storage Temp Mapping</DialogTitle>
        </DialogHeader>
        {/* Mounted only while open, so each opening starts from the saved mapping. */}
        {open && <ProductMappingTab onClose={onClose} />}
      </DialogContent>
    </Dialog>
  )
}
